"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilesWithSupportInfo = exports.getUploadingFilesWithSupportInfo = void 0;

var _reselect = require("reselect");

var _Files = require("FileManagerCore/selectors/Files");

var _fileFiltering = require("FileManagerLib/utils/fileFiltering");

var _Filter = require("FileManagerLib/selectors/Filter");

var getUploadingFiles = function getUploadingFiles(state) {
  return state.uploadingFiles.get('files').toList();
};

var getSelectedFolder = function getSelectedFolder(state) {
  return state.panel.getIn(['present', 'selectedFolder']);
};

var filterUploadingFiles = function filterUploadingFiles(uploadingFiles, selectedFolder) {
  if (selectedFolder) {
    var selectedFolderId = selectedFolder.get('id');
    return uploadingFiles.filter(function (file) {
      return file.get('folder_id') === selectedFolderId;
    });
  }

  return uploadingFiles;
};

var getFilteredUploadingFiles = (0, _reselect.createSelector)([getUploadingFiles, getSelectedFolder], filterUploadingFiles);
var getUploadingFilesWithSupportInfo = (0, _reselect.createSelector)([getFilteredUploadingFiles, _Filter.getFilter], _fileFiltering.addSupportInfoToFiles);
exports.getUploadingFilesWithSupportInfo = getUploadingFilesWithSupportInfo;
var getFilesWithSupportInfo = (0, _reselect.createSelector)([_Files.getFiles, _Filter.getFilter], _fileFiltering.addSupportInfoToFiles);
exports.getFilesWithSupportInfo = getFilesWithSupportInfo;